import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const state = {
  // 貼文牆的資料
  postWallData: [],
  // 目前貼文牆 load 到第幾頁
  postPageIndex: 0,
  // 是否已 load 完 API 請求(防止還沒執行完本次請求又發送一次新請求)
  isFinishLoad: false
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
